import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";

export const Logo = ({ light }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
    <svg width="30" height="30" viewBox="0 0 32 32" aria-hidden="true">
      <circle cx="16" cy="16" r="15" fill={light ? "#fff" : "#1E4D3A"} />
      <path d="M16 6c5 4 6 9 2 15-1 2-2 3-2 5-1-2-2-3-3-5-3-6-2-11 3-15z" fill="#B8903C" />
      <path d="M16 9v16" stroke={light ? "#1E4D3A" : "#fff"} strokeWidth="1.2" />
    </svg>
    <span className={`font-serif text-xl leading-none ${light ? "text-white" : "text-na-forest"}`}>Nativa Amazon</span>
  </Link>
);

export function BottleStack({ images = [], count = 1, size = "h-28" }) {
  const imgs = images.length > 1 ? images : Array.from({ length: count }, () => images[0]);
  return (
    <div className="flex items-end justify-center">
      {imgs.slice(0, Math.max(count, imgs.length)).map((src, i) => (
        <img key={i} src={fileUrl(src)} alt="" loading="lazy" className={`prod-img ${size} w-auto object-contain ${i ? "-ml-6" : ""}`} style={{ zIndex: 10 - i }} />
      ))}
    </div>
  );
}

export function Price({ p, big }) {
  return (
    <div>
      {p.preco_de > p.preco && <span className="mr-2 text-sm text-na-ink2 line-through">{(p.preco_de).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</span>}
      <span className={`${big ? "text-3xl" : "text-lg"} font-bold text-na-ink`}>{p.preco.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</span>
    </div>
  );
}
